import LatLngRenderer from '../renderers/LatLngRenderer';
import HotPolyline from '../core/HotPolyline';
import useCustomHotline from './useCustomHotline';
/**
 * Hotline with default Renderer and Polyline
 * @param opts hotline options
 * @returns the renderer and hotline instance
 */
function useHotline(opts) {
    const hotline = useCustomHotline(LatLngRenderer, (HotPolyline), opts);
    return hotline;
}
export default useHotline;
